// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================
   PREMIUM API SECTION - HEXAGONAL GRID
======================== */

.api-section {
    padding: 120px 0;
    position: relative;
    overflow: hidden;
}

/* ========================
   SECTION HEADER
======================== */

.section-header {
    text-align: center;
    margin-bottom: 100px;
    animation: fadeInUp 0.8s ease-out;
}

.section-badge {
    display: inline-block;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.section-title {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.section-subtitle {
    font-size: 1.125rem;
    color: rgba(255, 255, 255, 0.75);
    font-weight: 500;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ========================
   API GRID - OFFSET LAYOUT
======================== */

.api-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px 60px;
    max-width: 1100px;
    margin: 0 auto;
}

/* ========================
   API CARD - SIMPLIFIED DESIGN
======================== */

.api-card {
    position: relative;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.05));
    border: 1px solid rgba(139, 92, 246, 0.3);
    border-radius: 20px;
    padding: 40px 32px;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out both;
}

.api-card[data-index="0"] { animation-delay: 0.1s; }
.api-card[data-index="1"] { animation-delay: 0.2s; }
.api-card[data-index="2"] { animation-delay: 0.3s; }
.api-card[data-index="3"] { animation-delay: 0.4s; }
.api-card[data-index="4"] { animation-delay: 0.5s; }
.api-card[data-index="5"] { animation-delay: 0.6s; }

.api-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.1));
    opacity: 0;
    transition: opacity 0.5s ease;
}

.api-card:hover::before {
    opacity: 1;
}

.api-card:hover {
    transform: translateY(-10px) scale(1.02);
    border-color: rgba(168, 85, 247, 0.5);
    box-shadow: 
        0 25px 60px rgba(99, 102, 241, 0.3),
        0 0 60px rgba(168, 85, 247, 0.2);
}

/* ========================
   CARD TEXT
======================== */

.api-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 14px;
    line-height: 1.3;
    position: relative;
    z-index: 2;
}

.api-description {
    font-size: 0.9375rem;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.7;
    margin-bottom: 28px;
    min-height: 140px;
    position: relative;
    z-index: 2;
}

/* ========================
   BUTTONS
======================== */

.api-actions {
    display: flex;
    gap: 12px;
    position: relative;
    z-index: 2;
}

.api-btn-explore,
.api-btn-demo {
    flex: 1 1;
    padding: 14px 24px;
    border-radius: 12px;
    font-size: 0.9375rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.api-btn-explore {
    background: linear-gradient(135deg, #6366f1, #a855f7);
    color: #ffffff;
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.api-btn-explore:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(99, 102, 241, 0.5);
}

.api-btn-explore svg {
    transition: transform 0.3s ease;
}

.api-btn-explore:hover svg {
    transform: translateX(4px);
}

.api-btn-demo {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.api-btn-demo:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-3px);
}

/* ========================
   RESPONSIVE
======================== */

@media (max-width: 992px) {
    .api-grid {
        grid-template-columns: 1fr;
        gap: 32px;
    }
}

@media (max-width: 768px) {
    .api-section {
        padding: 80px 0;
    }

    .section-header {
        margin-bottom: 70px;
    }

    .api-card {
        padding: 32px 24px;
    }

    .api-description {
        min-height: auto;
    }

    .api-title {
        font-size: 1.25rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/APISection.css"],"names":[],"mappings":"AAAA;;0BAE0B;;AAE1B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;0BAE0B;;AAE1B;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;0BAE0B;;AAE1B;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;0BAE0B;;AAE1B;IACI,kBAAkB;IAClB,uFAAuF;IACvF,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;;AAEnD;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sFAAsF;IACtF,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC;;wCAEoC;AACxC;;AAEA;;0BAE0B;;AAE1B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;0BAE0B;;AAE1B;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,SAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;;0BAE0B;;AAE1B;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* ========================\n   PREMIUM API SECTION - HEXAGONAL GRID\n======================== */\n\n.api-section {\n    padding: 120px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ========================\n   SECTION HEADER\n======================== */\n\n.section-header {\n    text-align: center;\n    margin-bottom: 100px;\n    animation: fadeInUp 0.8s ease-out;\n}\n\n.section-badge {\n    display: inline-block;\n    padding: 8px 20px;\n    background: rgba(99, 102, 241, 0.15);\n    border: 1px solid rgba(139, 92, 246, 0.4);\n    border-radius: 50px;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\n}\n\n.section-title {\n    font-size: clamp(2rem, 4vw, 3.5rem);\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.section-subtitle {\n    font-size: 1.125rem;\n    color: rgba(255, 255, 255, 0.75);\n    font-weight: 500;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ========================\n   API GRID - OFFSET LAYOUT\n======================== */\n\n.api-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 40px 60px;\n    max-width: 1100px;\n    margin: 0 auto;\n}\n\n/* ========================\n   API CARD - SIMPLIFIED DESIGN\n======================== */\n\n.api-card {\n    position: relative;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.05));\n    border: 1px solid rgba(139, 92, 246, 0.3);\n    border-radius: 20px;\n    padding: 40px 32px;\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n    overflow: hidden;\n    animation: fadeInUp 0.6s ease-out both;\n}\n\n.api-card[data-index=\"0\"] { animation-delay: 0.1s; }\n.api-card[data-index=\"1\"] { animation-delay: 0.2s; }\n.api-card[data-index=\"2\"] { animation-delay: 0.3s; }\n.api-card[data-index=\"3\"] { animation-delay: 0.4s; }\n.api-card[data-index=\"4\"] { animation-delay: 0.5s; }\n.api-card[data-index=\"5\"] { animation-delay: 0.6s; }\n\n.api-card::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.1));\n    opacity: 0;\n    transition: opacity 0.5s ease;\n}\n\n.api-card:hover::before {\n    opacity: 1;\n}\n\n.api-card:hover {\n    transform: translateY(-10px) scale(1.02);\n    border-color: rgba(168, 85, 247, 0.5);\n    box-shadow: \n        0 25px 60px rgba(99, 102, 241, 0.3),\n        0 0 60px rgba(168, 85, 247, 0.2);\n}\n\n/* ========================\n   CARD TEXT\n======================== */\n\n.api-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 14px;\n    line-height: 1.3;\n    position: relative;\n    z-index: 2;\n}\n\n.api-description {\n    font-size: 0.9375rem;\n    color: rgba(255, 255, 255, 0.75);\n    line-height: 1.7;\n    margin-bottom: 28px;\n    min-height: 140px;\n    position: relative;\n    z-index: 2;\n}\n\n/* ========================\n   BUTTONS\n======================== */\n\n.api-actions {\n    display: flex;\n    gap: 12px;\n    position: relative;\n    z-index: 2;\n}\n\n.api-btn-explore,\n.api-btn-demo {\n    flex: 1;\n    padding: 14px 24px;\n    border-radius: 12px;\n    font-size: 0.9375rem;\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.api-btn-explore {\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    color: #ffffff;\n    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);\n}\n\n.api-btn-explore:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 10px 30px rgba(99, 102, 241, 0.5);\n}\n\n.api-btn-explore svg {\n    transition: transform 0.3s ease;\n}\n\n.api-btn-explore:hover svg {\n    transform: translateX(4px);\n}\n\n.api-btn-demo {\n    background: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.95);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.api-btn-demo:hover {\n    background: rgba(255, 255, 255, 0.15);\n    transform: translateY(-3px);\n}\n\n/* ========================\n   RESPONSIVE\n======================== */\n\n@media (max-width: 992px) {\n    .api-grid {\n        grid-template-columns: 1fr;\n        gap: 32px;\n    }\n}\n\n@media (max-width: 768px) {\n    .api-section {\n        padding: 80px 0;\n    }\n\n    .section-header {\n        margin-bottom: 70px;\n    }\n\n    .api-card {\n        padding: 32px 24px;\n    }\n\n    .api-description {\n        min-height: auto;\n    }\n\n    .api-title {\n        font-size: 1.25rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
